module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1106.0d32e7db.png";